<template>
  <div v-if="winner_image">
    <dialog open style="margin-top: 370px">
      <h3>{{full_name}} you win ${{win_dollar}}</h3>
      We will contact you to arrange the details.
    </dialog>
    <img :src=winner_image alt="wheel" width="100%"/>
  </div>
  <div v-else>
<!--    Empty-->
  </div>
</template>


<script>

export default {
  name: 'WinnerPage',
  components: {
  },
  data() {
    return {

    };
  },
  props: {
    winner_image: null,
    win_dollar: null,
    full_name: null,
  },
  mounted() {

  },
  watch: {
    // signedIn: async function() {
    // },
  },
  methods: {

  }
}

</script>
